import { makeStyles } from "@material-ui/core/styles";

// Two-tone the slider rail by team side (split at midfield), matching the
// in-game field bar. leftColor/rightColor are resolved by the caller from the
// team colors + the reversed/swap orientation.
const fieldRulerStyles = makeStyles(() => ({
	teamRail: {
		"& .MuiSlider-rail": {
			opacity: 1,
			height: 6,
			borderRadius: 3,
			background: ({ leftColor, rightColor }) =>
				`linear-gradient(to right, ${leftColor} 0 50%, ${rightColor} 50% 100%)`
		}
	},
	hiddenRail: {
		"& .MuiSlider-rail": {
			opacity: 0
		}
	}
}));

export default fieldRulerStyles;
